export const statusAssets = [
  {key: 'ASSET_ATIVO', name: 'Ativos'},
  {key: 'ASSET_AGUARDANDO_ATIVACAO', name: 'Aguardando ativação'} ,
  {key: 'ASSET_INATIVO', name: 'Inativos'},
]

export const statusOrders = [
  {key: 'CANCELADO', name: 'Cancelado'},
  {key: 'EM ANDAMENTO', name: 'Em andamento'},
  {key: 'EM CANCELAMENTO', name: 'Em cancelamento'},
  {key: 'EM ELABORAÇÃO', name: 'Em elaboração'},
  {key: 'EM EXECUÇÃO', name: 'Em execução'},
]



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ClientDetails/ClientDetailsDash/constants.js